import { render, staticRenderFns } from "./merchantTree.vue?vue&type=template&id=57bfa190&scoped=true&"
import script from "./merchantTree.vue?vue&type=script&lang=js&"
export * from "./merchantTree.vue?vue&type=script&lang=js&"
import style0 from "./merchantTree.vue?vue&type=style&index=0&id=57bfa190&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bfa190",
  null
  
)

export default component.exports